// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store"
import VueTouch from "vue-touch"
import VuexForms from "vuex-forms"

Vue.use(VueTouch, {name: 'v-touch'})
Vue.use(VuexForms)

import * as filters from "./utils/filters"
Object.keys(filters).forEach(function (key, index) {
    Vue.filter(key, filters[key])
});

import Icons from "./components/Icons.vue"
import Loaders from "./components/Loaders.vue"
import PopupCart from "./components/PopupCart.vue"
import ImageSlider from "./components/ImageSlider.vue"
import ColorDisplay from "./components/ColorDisplay.vue"
import ProductDisplay from "./components/ProductDisplay.vue"
import ColorSelect from "./components/ColorSelect.vue"
import ProductSelect from "./components/ProductSelect.vue"
Vue.component('icons', Icons)
Vue.component('loaders', Loaders)
Vue.component('paypal', PayPal)
Vue.component('popup-cart', PopupCart)
Vue.component('image-slider', ImageSlider)
Vue.component('color-display', ColorDisplay)
Vue.component('product-display', ProductDisplay)
Vue.component('color-select', ColorSelect)
Vue.component('product-select', ProductSelect)

import FormText from "./components/forms/FormText.vue"
import FormSelect from "./components/forms/FormSelect.vue"
import ShippingForm from "./components/ShippingForm.vue"
import ShippingOptions from "./components/ShippingOptions.vue"
import PayPal from "./components/Paypal.vue"
Vue.component('paypal', PayPal)
Vue.component('form-text', FormText)
Vue.component('form-select', FormSelect)
Vue.component('shipping-form', ShippingForm)
Vue.component('shipping-options', ShippingOptions)


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js